import { createApi } from "@reduxjs/toolkit/query/react";

import type { VenueDTO } from "../../../../common/types/VenueDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const venueService = createApi({
  reducerPath: "venueService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Venue"],
  endpoints: (builder) => ({
    getVenue: builder.query<VenueDTO, { id: number }>({
      query: ({ id }) => `api/identity/venues/${id}`,
      providesTags: (venue) => [{ type: "Venue", id: venue?.id }],
    }),
  }),
});

export const { useGetVenueQuery } = venueService;
